import { disableScroll, enableScroll } from "./scroll-lock";

window.overlayActiveElement = null;

// TODO: NTH pri zobrazeni a skryti transition pekny (podla vue, tam tie transition el)
function baseShow(activeElement, overlay, allowScroll) {
    window.overlayActiveElement = activeElement;

    requestAnimationFrame(() => {
        overlay.classList.add("is-active");

        if (!allowScroll) {
            disableScroll();
        }
    });
}

function baseHide(activeElement, overlays) {
    if (activeElement !== window.overlayActiveElement) {
        return;
    }

    overlays.forEach((element) => {
        element.classList.remove("is-active");
    });

    if (document.body.classList.contains("is-overlayed")) {
        enableScroll();
    }

    window.overlayActiveElement = null;
}

function showOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, document.querySelector(".js-overlay"), allowScroll);
}

function hideOverlay(activeElement) {
    baseHide(activeElement, document.querySelectorAll(".js-overlay, .js-header-overlay"));
}

function showHeaderOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, document.querySelector(".js-header-overlay"), allowScroll);
}

function hideHeaderOverlay(activeElement) {
    baseHide(activeElement, document.querySelectorAll(".js-header-overlay"));
}

export { showOverlay, hideOverlay, showHeaderOverlay, hideHeaderOverlay };
